import { NavigateFunction, Location } from 'react-router-dom';

let navigate: NavigateFunction | null = null;
let location: Location | null = null;

export function getNavigate(): NavigateFunction | null {
  return navigate;
}

export function getLocation(): Location | null {
  return location;
}

export function setNavigate(ref: NavigateFunction): void {
  navigate = ref;
}

export function setLocation(ref: Location): void {
  location = ref;
}
